export const MESSAGE_LIST_GENERIC_ACTIVITY_LIST_SORT = 'MESSAGE_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const MESSAGE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'MESSAGE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
